import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SplitOptions',
})
export class SplitOptionsPipe implements PipeTransform {
  transform(options: string): string[] {
    return options.split('#');
  }
}
